import React from "react";
import { Box } from "@mui/system";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { QuestionFooter } from "./QuestionFooter";


export function MultipleChoiceComponent({
  initialValues,
  question,
  options = [],
  addAnswer,
  previous,
  next,
  loadingAnswer,
}) {
  const { setFieldValue, handleSubmit, values, isValid, errors } = useFormik({
    initialValues: {
      answers: initialValues ?? [],
      required: question?.required,
    },
    onSubmit: async (values, {setSubmitting}) => {
      setSubmitting(true)
      const answers = values.answers.map((each) => ({
        questionId: question.id,
        answerText: each?.text,
      }));
      
      const proceed = await addAnswer(question.id, answers);
      setSubmitting(false)
      if(proceed){ // false if answer is not added to the backend
        next();
      }
    },
    validationSchema: Yup.object().shape({
        answers: Yup.array()
        .required("Es muss eine Antwort ausgewählt werden.")
        .min(1, "Es muss eine Antwort ausgewählt werden.")      
    }),
  });

  const isChecked = (option) =>
    values.answers.find((each) => each.id === option.id);

  const handleChecked = (option) => {
    if (isChecked(option)) {
      const newAnswers = values.answers.filter((each) => each.id !== option.id);
      setFieldValue("answers", newAnswers);
    } else setFieldValue("answers", [...values.answers, option]);
  };

  options = options.map((each, index) => ({...each, sequenceNumber: each?.sequenceNumber ??  index}) )

  return (
    <div className="survey-choice">
      <div className="survey-answer-list">
      {options
        .sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1))
        .map((eachOption) => (
          <div key={eachOption.sequenceNumber} className="survey-answer-item">
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  onChange={() => handleChecked(eachOption)}
                  checked={isChecked(eachOption)}
                  sx={{
                    padding: "0px",
                    "& svg": {
                      width: "31px",
                      height: "31px",
                      padding: "0px",
                      color: "#238CB9",
                    },
                  }}
                />
              }
              label={eachOption.text}
              sx={{
                alignItems: "start !important",
                color: "#238CB9",
                padding: "0px",
                "& .MuiFormControlLabel-label": {
                  marginLeft: "18px",
                },
              }}
              labelPlacement="end"
            />
          </div>
        ))}
      </div>
      <QuestionFooter 
        back={previous}
        onSave={handleSubmit}
        isValid={isValid}
        showErrorModal={typeof errors.answers === "string" ? errors.answers : ""}
        isSubmitting={loadingAnswer} 
      />
    </div>
  );
}
